import React from 'react';

export default function Experience() {
  return (
    <section
      id="experience"
      className="scroll-mt-24 py-20 px-6 bg-white text-gray-800"
      data-aos="fade-up"
    >
      <div className="max-w-4xl mx-auto text-left">
        <h2 className="text-3xl font-bold mb-4 transition-colors duration-300 hover:text-green-700 text-center">
          Academic & Technical Experience
        </h2>

        <p className="text-center text-gray-600 mb-10">
          Professional experience across academic libraries and digital repository systems,
          with emphasis on automation, metadata curation, and knowledge-based discovery.
        </p>

        <div className="space-y-6">
          {[
            {
              title: 'Associate',
              place: 'Connectberg Technologies Pvt. Ltd.',
              duration: 'Sep 2024 – May 2025',
              points: [
                'Led library modernization and automation initiatives using KOHA and DSpace.',
                'Designed and customized integrated library systems for academic and government institutions.',
              ],
            },
            {
              title: 'Library Trainee',
              place: 'IIT Hyderabad',
              duration: 'Feb 2023 – Aug 2024',
              points: [
                'Supported acquisitions and technical processing workflows, including RFID-based circulation operations.',
                'Provided research assistance, database access support, and reference services.',
                'Worked extensively with KOHA, DSpace, and EPrints-based library platforms.',
              ],
            },
            {
              title: 'Library Intern',
              place: 'Digital University Kerala',
              duration: 'Mar 2022 – Feb 2023',
              points: [
                'Supported circulation operations, acquisitions, and metadata curation activities.',
                'Engaged in information retrieval, cataloguing, and knowledge organization tasks.',
              ],
            },
            {
              title: 'Library Modernization Intern',
              place: 'Kerala State Election Commission',
              duration: 'Jan – Feb 2022',
              points: [
                'Modernized the institutional library using KOHA, including cataloguing and classification.',
                'Executed barcode labeling, spine labeling, and systematic collection arrangement.',
              ],
            },
            {
              title: 'Glossary Project Contributor',
              place: 'University of Kerala',
              duration: 'Nov – Dec 2021',
              points: [
                'Contributed to a trilingual LIS glossary (English–Hindi–Malayalam) under the Ministry of Education.',
              ],
            },
            {
              title: 'Library Modernization Intern',
              place: 'University of Kerala',
              duration: 'Oct – Nov 2021',
              points: [
                'Performed data entry and automation setup using KOHA.',
                'Organized, structured, and labeled physical collections.',
              ],
            },
          ].map((job, i) => (
            <div
              key={i}
              className="bg-gray-50 p-5 rounded-xl shadow-md hover:shadow-xl transform hover:scale-[1.02] transition duration-300"
            >
              <h3 className="text-xl font-semibold mb-1">{job.title}</h3>
              <p className="text-gray-700 italic">
                {job.place} ({job.duration})
              </p>
              <ul className="list-disc ml-6 mt-2 text-gray-700 space-y-1">
                {job.points.map((point, j) => (
                  <li key={j}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
